export default __webpack_public_path__ + "static/media/killi.7aa770ad.svg";